export default "__VITE_PUBLIC_ASSET__85d7e08b__"